import PropTypes from 'prop-types';
import React from 'react';
import Switch from 'react-switch';

import { IS_ADMIN } from '../../config';

const SwitchModes = ({ handleLiveChange, isLive, disableSwitch }) => {
  return (
    !IS_ADMIN && (
      <button className="navbar__menu-item switch" id="test_live_switch">
        <span>Test</span>
        <Switch
          onChange={handleLiveChange}
          checked={Boolean(isLive)}
          uncheckedIcon={false}
          checkedIcon={false}
          disabled={Boolean(disableSwitch)}
          height={24}
          width={50}
          offColor="#E0DFDF"
          onColor="#32BD9F"
        />
        <span>Live</span>
      </button>
    )
  );
};

SwitchModes.propTypes = {
  handleLiveChange: PropTypes.func,
  isLive: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disableSwitch: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export { SwitchModes };
